import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeletePreIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_15193_15410)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 30,
					cy: 30,
					r: 30,
					fill: "#F0FAF8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.75 22.5C21.8338 22.5 21.8757 22.5 21.9137 22.499C23.1489 22.4677 24.2385 21.6824 24.6588 20.5205C24.6718 20.4847 24.685 20.445 24.7115 20.3655L24.8571 19.9286C24.9815 19.5556 25.0436 19.3691 25.1261 19.2108C25.455 18.5791 26.0636 18.1405 26.7669 18.0281C26.9432 18 27.1398 18 27.5329 18H32.4671C32.8602 18 33.0568 18 33.2331 18.0281C33.9364 18.1405 34.545 18.5791 34.8739 19.2108C34.9564 19.3691 35.0185 19.5556 35.1429 19.9286L35.2885 20.3655C35.315 20.4449 35.3283 20.4848 35.3412 20.5205C35.7615 21.6824 36.8511 22.4677 38.0863 22.499C38.1243 22.5 38.1662 22.5 38.25 22.5",
					stroke: "#6BCABA",
					strokeWidth: 3
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42 22.5H18",
					stroke: "#6BCABA",
					strokeWidth: 3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33 28.5H27",
					stroke: "#865E9C",
					strokeWidth: 3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33 34.5H27",
					stroke: "#865E9C",
					strokeWidth: 3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.75 22.5L39.0937 33.2626C38.8412 37.4043 38.7149 39.4751 37.4807 40.7376C36.2465 42 34.3482 42 30.5517 42H29.4483C25.6518 42 23.7535 42 22.5193 40.7376C21.2851 39.4751 21.1588 37.4043 20.9063 33.2626L20.25 22.5",
					stroke: "#6BCABA",
					strokeWidth: 3,
					strokeLinecap: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_15193_15410",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 60,
				height: 60,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgDeletePreIcon);
export { ForwardRef as ReactComponent };
